// i18n-ready string registry. All user-facing chrome strings are centralized here.
// Polish (pl) localization can be added later by calling registerLocale("pl", {...})
// with zero component changes. Deep page content follows the same pattern as needed.

const dictionaries = {
  en: {
    "brand.name": "HUSSAR TREASURY",
    "brand.tagline": "Every Dollar Has a Job",
    "banner.modeLabel": "Execution Mode",
    "banner.paper": "Simulated fills at real market prices. No real capital at risk.",
    "banner.liveConfirm": "Every trade requires explicit human approval before execution.",
    "banner.liveAuto": "Risk-Governor-approved trades execute automatically.",
    "banner.emergency": "EMERGENCY STOP ACTIVE — all automated trading disabled. Monitoring and accounting continue.",
    "banner.taxUnderfunded": "TAX RESERVE UNDERFUNDED — coverage below 100%",
    "action.killSwitch": "STOP ALL AUTOMATED TRADING",
    "action.signOut": "Sign out",
    "action.signIn": "SIGN IN",
    "action.signingIn": "AUTHENTICATING…",
    "auth.authorizedOnly": "Authorized Hussar Holdings personnel only. All access is audited.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Name",
    "auth.confirmPassword": "Confirm Password",
    "auth.passwordRules": "Minimum 12 characters with upper & lower case letters, a digit, and a symbol.",
    "auth.bootstrapToggle": "First-time platform setup",
    "auth.bootstrapTitle": "Initialize Platform Owner",
    "auth.bootstrapDesc": "One-time secure initialization. This creates the first PLATFORM_OWNER account and permanently disables itself. Available only while no users exist.",
    "action.bootstrap": "CREATE PLATFORM OWNER",
    "action.bootstrapping": "INITIALIZING…",
    "nav.commandCenter": "Command Center",
    "nav.overview": "Overview",
    "nav.portfolio": "Portfolio",
    "nav.deploy": "Deploy Capital",
    "nav.strategies": "Strategies",
    "nav.venueIntelligence": "Venue Intelligence",
    "nav.hussarLab": "Hussar Lab",
    "nav.learningReport": "Learning Report",
    "nav.intelligenceArena": "Intelligence Arena",
    "nav.assurance": "Assurance",
    "nav.custody": "Custody",
    "nav.enterprise": "Enterprise",
    "nav.cash": "Cash",
    "nav.crypto": "Crypto",
    "nav.traditional": "Traditional Assets",
    "nav.yield": "Yield",
    "nav.opportunities": "Opportunities",
    "nav.wildcard": "Wildcard",
    "nav.intelligence": "Intelligence",
    "nav.taxLedger": "Tax Ledger",
    "nav.taxLots": "Tax Lots",
    "nav.transactions": "Transactions",
    "nav.journal": "Decision Journal",
    "nav.audit": "Audit Ledger",
    "nav.risk": "Risk Governor",
    "nav.performance": "Performance",
    "nav.connections": "Connections",
    "nav.settings": "Settings",
    "nav.commandCenter": "COMMAND CENTER",
  },
};

let currentLocale = "en";

export function setLocale(locale) {
  if (dictionaries[locale]) currentLocale = locale;
}

export function registerLocale(locale, dict) {
  dictionaries[locale] = { ...dictionaries.en, ...dict };
}

export function getLocale() {
  return currentLocale;
}

export function t(key) {
  return dictionaries[currentLocale]?.[key] ?? dictionaries.en[key] ?? key;
}
